<template>
  <div class='file-manager-main-content'>
    <div class='file-manager-content-header d-flex justify-content-between align-items-center'>
      <SearchContents />
      <span class='actions'>
        <slot name='actions' />
      </span>
    </div>
    <div class='file-manager-content-body'>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import SearchContents from '@/components/SearchContents'
import Ripple from 'vue-ripple-directive'

export default {
  directives: {
    Ripple
  },
  components: { SearchContents }
}
</script>

<style scoped lang='scss'>
.actions{
  button {
    margin-right: 2px;
  }
}
</style>
